export enum Types {
	TIPOS_INDIGENAS_REQUEST = '@EDUCACAO/TIPOS_INDIGENAS_REQUEST',
	TIPOS_INDIGENAS_SUCCESS = '@EDUCACAO/TIPOS_INDIGENAS_SUCCESS',
	TIPOS_INDIGENAS_FAILURE = '@EDUCACAO/TIPOS_INDIGENAS_FAILURE',
}

export interface TiposIndigenas {
	status: number;
	data: null | TiposIndigenasData;
}

interface TiposIndigenasData {
	processoId: string;
	indigenas: TipoIndigenasResponse[];
}

export interface TipoIndigenasResponse {
	codigoTipoIndigena: string;
	descricaoTipoIndigena: string;
}
